var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 565.488,
    height: 431.785,
    viewBox: "0 0 565.488 431.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_subscriber_re_om92",
    transform: "translate(-318.48 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M930.734,274.341h-.125l-71.49,30.527-97.813,41.767a3.155,3.155,0,0,1-2.416.012L657.975,304.78l-73.246-30.39-.112-.05h-.125a4.364,4.364,0,0,0-4.359,4.359V468.012a4.364,4.364,0,0,0,4.359,4.359H930.734a4.364,4.364,0,0,0,4.359-4.359V278.7a4.364,4.364,0,0,0-4.359-4.359Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M931.045,275.586a.621.621,0,0,1-.355-.112L758.466,155.533a3.123,3.123,0,0,0-3.567.006L583.916,275.473a.623.623,0,1,1-.715-1.02L754.184,154.519a4.373,4.373,0,0,1,4.994-.008L931.4,274.452a.623.623,0,0,1-.356,1.134Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M435.67,133.57,598.834,12.645l164.4,129.529-156,92.476-84.692-19.3Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M687.714,438.037H607.107a3.766,3.766,0,1,1-.011-7.532h80.618a3.766,3.766,0,0,1,.011,7.532Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#2b2f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M636.027,421.846h-28.92a3.766,3.766,0,1,1-.011-7.532h28.931a3.766,3.766,0,1,1,.011,7.532Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#2b2f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M759.145,347.191a4.711,4.711,0,0,1-1.787-.35L656.73,305.087v-130.7a4.364,4.364,0,0,1,4.359-4.359H854.137a4.364,4.364,0,0,1,4.359,4.359V305.179l-.189.081-97.322,41.561a4.744,4.744,0,0,1-1.841.37Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M759.145,347.5a5.026,5.026,0,0,1-1.905-.373L656.418,305.3v-130.9a4.676,4.676,0,0,1,4.671-4.671H854.137a4.676,4.676,0,0,1,4.671,4.671V305.384l-97.7,41.723A5.05,5.05,0,0,1,759.145,347.5ZM657.664,304.463l100.051,41.515a3.81,3.81,0,0,0,2.907-.017l96.94-41.4V174.391a3.429,3.429,0,0,0-3.425-3.425H661.089a3.429,3.429,0,0,0-3.425,3.425Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M929.8,274.341h-.125l-71.49,30.526-97.813,41.767a3.155,3.155,0,0,1-2.416.012L657.041,304.78l-73.246-30.39-.112-.05h-.125A4.364,4.364,0,0,0,579.2,278.7V468.012a4.364,4.364,0,0,0,4.359,4.359H929.8a4.364,4.364,0,0,0,4.359-4.359V278.7a4.364,4.364,0,0,0-4.359-4.359Zm3.114,193.671a3.115,3.115,0,0,1-3.114,3.114H583.558a3.115,3.115,0,0,1-3.114-3.114V278.7a3.121,3.121,0,0,1,3-3.114l73.6,30.539L757.476,347.8a4.435,4.435,0,0,0,3.388-.019l97.321-41.562,71.739-30.632a3.124,3.124,0,0,1,2.989,3.114Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M743.479,218.887h-68.5a4.982,4.982,0,0,1,0-9.964h68.5a4.982,4.982,0,0,1,0,9.964Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#2b2f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M707.983,197.714h-33a4.982,4.982,0,0,1,0-9.964h33.005a4.982,4.982,0,0,1,0,9.964Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#2b2f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M808.847,268.706H704.227a4.982,4.982,0,0,1,0-9.964h104.62a4.982,4.982,0,0,1,0,9.964Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M808.847,291.747H704.227a4.982,4.982,0,0,1,0-9.964h104.62a4.982,4.982,0,0,1,0,9.964Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 47.371,
    cy: 47.371,
    r: 47.371,
    transform: "translate(722.482 82.507)",
    fill: "#2b2f68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M765.339,149.875l-14.178-18.231,8.245-6.413,6.713,8.632L788.8,109.922l7.584,7.185Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M487.352,193.546a2,2,0,0,0-3,1.991L485.9,206.86a1.3,1.3,0,0,1-.034.5,1.221,1.221,0,0,1-.237.436l-8.647,10.244a1.954,1.954,0,0,0-.127,2.414l.009.013a1.951,1.951,0,0,0,2.283.752l6.244-2.119a1.2,1.2,0,0,1,1.208.272,1.162,1.162,0,0,1,.372.854l.244,22.249a1.984,1.984,0,0,0,.874,1.629,2,2,0,0,0,1.832.213l46.607-17.824a2,2,0,0,0,.307-3.586l-.635-.377-48.847-28.982Zm-2.209,1.882a1.2,1.2,0,0,1,1.8-1.193l48.832,28.974.65.385a1.2,1.2,0,0,1-.183,2.151L489.637,243.57a1.2,1.2,0,0,1-1.624-1.106l-.244-22.249a1.915,1.915,0,0,0-.112-.646l47.45,5.452a.8.8,0,0,0,.48-1.5.7.7,0,0,0-.125-.054L486.7,207.194a1.97,1.97,0,0,0-.014-.442l-1.544-11.323Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M487.352,193.546a2,2,0,0,0-3,1.991L485.9,206.86a1.3,1.3,0,0,1-.034.5,1.221,1.221,0,0,1-.237.436l-8.647,10.244a1.954,1.954,0,0,0-.127,2.414l.009.013a1.951,1.951,0,0,0,2.283.752l6.244-2.119a1.2,1.2,0,0,1,1.208.272,1.162,1.162,0,0,1,.372.854l.244,22.249a1.984,1.984,0,0,0,.874,1.629,2,2,0,0,0,1.832.213l46.607-17.824a2,2,0,0,0,.307-3.586l-.635-.377-48.847-28.982Zm-2.209,1.882a1.2,1.2,0,0,1,1.8-1.193l48.832,28.974.65.385a1.2,1.2,0,0,1-.183,2.151L489.637,243.57a1.2,1.2,0,0,1-1.624-1.106l-.244-22.249a1.914,1.914,0,0,0-.112-.646,1.943,1.943,0,0,0-.512-.782c-.032-.032-.066-.061-.1-.09l0,0a1.992,1.992,0,0,0-1.908-.351l-6.248,2.122a1.162,1.162,0,0,1-1.369-.456l0-.007a1.16,1.16,0,0,1,.077-1.447l8.647-10.243a1.885,1.885,0,0,0,.239-.35l0,0a1.917,1.917,0,0,0,.152-.377,1.853,1.853,0,0,0,.071-.389,1.972,1.972,0,0,0-.014-.442l-1.544-11.323Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M486.7,207.194l48.76,16.276a.7.7,0,0,1,.125.054.8.8,0,0,1-.48,1.5l-47.45-5.452-.838-.1.093-.792.13.012,0,0,48.154,5.529-48.72-16.266,0,0-.211-.073.253-.758Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1031.13,146.546l-48.849,28.982-.635.377a2,2,0,0,0,.307,3.586l46.607,17.825a2,2,0,0,0,1.833-.213,1.984,1.984,0,0,0,.874-1.629l.244-22.249a1.162,1.162,0,0,1,.372-.854,1.2,1.2,0,0,1,1.208-.272l6.245,2.12a1.951,1.951,0,0,0,2.283-.752l.009-.013a1.954,1.954,0,0,0-.127-2.413l-8.647-10.244a1.223,1.223,0,0,1-.237-.436,1.3,1.3,0,0,1-.033-.5l1.544-11.323a2,2,0,0,0-3-1.991Zm2.209,1.882-1.544,11.323a1.981,1.981,0,0,0-.014.442L983.018,176.47a.694.694,0,0,0-.125.054.8.8,0,0,0,.48,1.5l47.45-5.452a1.916,1.916,0,0,0-.112.646l-.244,22.249a1.2,1.2,0,0,1-1.624,1.106l-46.607-17.825a1.2,1.2,0,0,1-.183-2.151l.65-.385,48.832-28.973a1.2,1.2,0,0,1,1.8,1.193Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1031.13,146.546l-48.849,28.982-.635.377a2,2,0,0,0,.307,3.586l46.607,17.825a2,2,0,0,0,1.833-.213,1.984,1.984,0,0,0,.874-1.629l.244-22.249a1.162,1.162,0,0,1,.372-.854,1.2,1.2,0,0,1,1.208-.272l6.245,2.12a1.951,1.951,0,0,0,2.283-.752l.009-.013a1.954,1.954,0,0,0-.127-2.413l-8.647-10.244a1.223,1.223,0,0,1-.237-.436,1.3,1.3,0,0,1-.033-.5l1.544-11.323a2,2,0,0,0-3-1.991Zm2.209,1.882-1.544,11.323a1.974,1.974,0,0,0-.014.442,1.856,1.856,0,0,0,.071.389,1.907,1.907,0,0,0,.152.377l0,0a1.893,1.893,0,0,0,.239.35l8.647,10.243a1.16,1.16,0,0,1,.077,1.447l0,.007a1.162,1.162,0,0,1-1.369.456l-6.248-2.122a1.992,1.992,0,0,0-1.908.351l0,0c-.035.029-.07.059-.1.09a1.943,1.943,0,0,0-.512.782,1.916,1.916,0,0,0-.112.646l-.244,22.249a1.2,1.2,0,0,1-1.624,1.106l-46.607-17.825a1.2,1.2,0,0,1-.183-2.151l.65-.385,48.832-28.973a1.2,1.2,0,0,1,1.8,1.193Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1031.96,160.131l.253.758-.211.073,0,0-48.72,16.266,48.154-5.529,0,0,.13-.012.093.792-.838.1-47.45,5.452a.8.8,0,0,1-.479-1.5.7.7,0,0,1,.125-.054l48.761-16.276Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M613.142,551.49a2,2,0,0,0,.081,3.6l10.4,4.747a1.3,1.3,0,0,1,.4.3,1.222,1.222,0,0,1,.242.434l4.037,12.783a1.954,1.954,0,0,0,1.972,1.4h.016a1.951,1.951,0,0,0,1.856-1.527l1.546-6.411a1.2,1.2,0,0,1,.875-.875,1.162,1.162,0,0,1,.921.142l18.936,11.684a1.984,1.984,0,0,0,1.844.132,2,2,0,0,0,1.16-1.435l9.842-48.919a2,2,0,0,0-2.868-2.176l-.658.335Zm.41,2.873a1.2,1.2,0,0,1-.045-2.16l50.585-25.79.673-.344a1.2,1.2,0,0,1,1.72,1.3l-9.842,48.919a1.2,1.2,0,0,1-1.8.782L635.906,565.39a1.914,1.914,0,0,0-.606-.251l29.967-37.192a.8.8,0,0,0-1.009-1.205.693.693,0,0,0-.113.076l-39.816,32.515a1.972,1.972,0,0,0-.381-.224l-10.4-4.747Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M613.142,551.49a2,2,0,0,0,.081,3.6l10.4,4.747a1.3,1.3,0,0,1,.4.3,1.222,1.222,0,0,1,.242.434l4.037,12.783a1.954,1.954,0,0,0,1.972,1.4h.016a1.951,1.951,0,0,0,1.856-1.527l1.546-6.411a1.2,1.2,0,0,1,.875-.875,1.162,1.162,0,0,1,.921.142l18.936,11.684a1.984,1.984,0,0,0,1.844.132,2,2,0,0,0,1.16-1.435l9.842-48.919a2,2,0,0,0-2.868-2.176l-.658.335Zm.41,2.873a1.2,1.2,0,0,1-.045-2.16l50.585-25.79.673-.344a1.2,1.2,0,0,1,1.72,1.3l-9.842,48.919a1.2,1.2,0,0,1-1.8.782L635.906,565.39a1.917,1.917,0,0,0-.606-.251,1.943,1.943,0,0,0-.935.015c-.044.01-.087.024-.13.037h0a1.992,1.992,0,0,0-1.316,1.425l-1.546,6.415a1.162,1.162,0,0,1-1.117.913h-.008a1.16,1.16,0,0,1-1.182-.838l-4.037-12.783a1.888,1.888,0,0,0-.168-.389v0a1.91,1.91,0,0,0-.237-.33,1.862,1.862,0,0,0-.291-.268,1.968,1.968,0,0,0-.381-.224l-10.4-4.747Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M624.329,559.333l39.816-32.515a.691.691,0,0,1,.113-.077.8.8,0,0,1,1.009,1.205L635.3,565.139l-.528.657-.62-.5.08-.1h0l30.408-37.746-39.785,32.486v0l-.174.139-.505-.619Z",
    transform: "translate(-158.016 -146.268)",
    fill: "#e5e5e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriber);
export default __webpack_public_path__ + "static/media/subscriber.697e630a.svg";
export { ForwardRef as ReactComponent };